module.exports = __webpack_public_path__ + "img/image-order-status--6.a3e27c5f.png";